
export enum TAB {
  PRODUCT = "PRODUCT",
  SHOWCASE = "SHOWCASE",
  TRAY = "TRAY",
  EXTRA_TRAY = "EXTRA_TRAY",
  ACTIVITY = "ACTIVITY",
  BASKET = "BASKET",
}

const sapCode = {
  key: 'sapCode',
  label: 'TABLE.SAP_CODE',
  showLabel: true,
  hasAvatar: true,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};
const catalogCode = {
  key: 'catalogCode',
  label: 'TABLE.CATALOG_CODE',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: false
};

const aestheticLine = {
  key: 'aestheticLine',
  label: 'TABLE.NAME',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};

const category = {
  key: 'category',
  label: 'TABLE.CATEGORY',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};

const hjRepetitive = {
  key: 'hjRepetitive',
  label: 'TABLE.REPRODUCIBILITY',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true
};

const notes = {
  key: 'notes',
  label: 'TABLE.NOTES',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true
};

const logisticStatus = {
  key: 'logisticStatus',
  label: 'TABLE.ARRIVED',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: true,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true,
  isSortable: true
};

// const liveStatus = {
//   key: 'liveStatus',
//   label: 'TABLE.LIVE_STATUS',
//   showLabel: true,
//   hasAvatar: false,
//   hasIcon: false,
//   hasSelect: true,
//   hasEditable: true,
//   hasTooltip: true,
//   isVisible: true,
//   isSortable: true
// };

const isBackup = {
  key: 'isBackup',
  label: 'TABLE.IS_BACKUP',
  showLabel: true,
  hasAvatar: false,
  hasIcon: true,
  hasSelect: false,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true,
  isSortable: false
};

const isClientView = {
  key: 'isClientView',
  label: 'TABLE.IS_CLIENTVIEW',
  showLabel: true,
  hasAvatar: false,
  hasIcon: true,
  hasSelect: false,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true,
  isSortable: false
};

const isAvailableForAllocation = {
  key: 'isAvailableForAllocation',
  label: 'TABLE.AVAILABLE_ALLOCATION',
  showLabel: true,
  hasAvatar: false,
  hasIcon: true,
  hasSelect: false,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true,
  isSortable: false
};

const allocation = {
  key: 'allocation',
  label: 'TABLE.ALLOCATION',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};
const tray = {
  key: 'tray',
  label: 'TABLE.TRAY',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};

const allocationStatus = {
  key: 'allocationStatus',
  label: 'TABLE.STATUS',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};

const salesTeamStatus = {
  key: 'salesTeamStatus',
  label: 'TABLE.SALES_TEAM_STATUS',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
};

const hasBookedForSale = {
  key: 'hasBookedForSale',
  label: 'TABLE.HASBOOKEDFORSALE',
  showLabel: true,
  hasAvatar: false,
  hasIcon: true,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: false
};


const activities = {
  key: 'activities',
  label: 'TABLE.ACTIVITIES',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: true,
  hasTooltip: true,
  isVisible: true,
  isSortable: true
};

const isHeroSelectionList = {
  key: 'isHeroSelectionList',
  label: 'TABLE.DW',
  showLabel: true,
  hasAvatar: false,
  hasIcon: true,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: false
};

const extraTray = {
  key: 'extraTray',
  label: 'TABLE.EXTRA_TRAY',
  showLabel: true,
  hasAvatar: false,
  hasIcon: false,
  hasSelect: false,
  hasEditable: false,
  hasTooltip: false,
  isVisible: true,
  isSortable: true
}


export const PRODUCTS_TABLE_CONFIGURATION = [
  sapCode,
  catalogCode,
  aestheticLine,
  category,
  hjRepetitive,
  notes,
  logisticStatus,
  allocationStatus,
  salesTeamStatus,
  isBackup,
  isClientView,
  // liveStatus,
  allocation,
  tray,
  extraTray,
  hasBookedForSale,
  // activities,
  isHeroSelectionList,
  isAvailableForAllocation,
]











